import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";


const Collaborations = () => {
  useEffect(() => {


  }, [])

  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Collaborations</h1>
        <h3>Spot the Fake. Safeguard the Cure.</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Collaborations
            </div>
            <Scrollspy
            offset={-140}
              className="scrollspy" items={['CCiC', 'iGBA_2nd_Forum', 'HK-Macau_Symposium', 'APAC_Symposium']}
              currentClassName="active">

              <li><a href="#CCiC">11th Conference of China iGEMer Community (CCiC)</a></li>
              <li><a href="#iGBA_2nd_Forum">2nd iGEM Greater Bay Area Forum</a></li>
              <li><a href="#HK-Macau_Symposium">2024 HK-Macau iGEM Symposium</a></li>
              <li><a href="#APAC_Symposium">APAC Symposium: Mock Jamboree</a></li>

            </Scrollspy>

            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/mascot/mascot-holding-placard-1.png"
              alt="Mascot is holding placard"
            />

          </div>

        </div>

        <div className="main_lab_style Collaborations_page">
          <WindowBrowser description={
            <div>
              <>
                <p id="Collaborations">
                  <h1>
                    Conferences & Symposiums
                    <br />
                  </h1>
                </p>
                <p>
                  At BevaTech, meaningful dialogue and collaboration serve as the basis for advancing the field of synthetic biology. For this reason, we have taken the initiative to participate in and give talks at a series of leading conferences and symposiums attended by students, academics, and professionals from the industry who are involved in sharing the current developments in the field and challenges being faced. These events provide invaluable opportunities for our team to engage and exchange ideas with peers and experts in the region and global synthetic biology community.
                </p>
                <p>
                  Throughout the season, we attended several critical events in the region, including the 11th Conference of China iGEMer Community (CCiC), 2nd iGEM Greater Bay Area Forum (iGBA), 2024 HK-Macau iGEM Symposium, and APAC Symposium: Mock Jamboree, where we could share our project and receive constructive feedback from fellow participants. These have enforced our knowledge of our LFA application in detecting counterfeit drugs and fueled new directions and actions to be taken in research and development throughout the competition.
                </p>
                <p>
                  This section shall detail our experience from these symposiums and conferences, highlighting the key lessons learned and the impact of these engagements on our project. Our participation in these events has been instrumental in refining our approach, fostering collaborations and contributing to broader discourse on synthetic biology.
                </p>

                <section id="CCiC">
                  <br />
                  <br />

                  <h1>
                    11th Conference of China iGEMer Community (CCiC)
                  </h1>

                  <p>
                    The China iGEMer Community Conference is a national event that brings iGEM teams across China. It serves as a platform for synthetic biology enthusiasts to share knowledge, promote learning and explore the future of the field. This conference includes presentations, poster sessions and collaborative discussions, which enable teams to gain and connect with experts in the field.
                  </p>
                  <p>
                    At the 11th CCiC, BevaTech delivered a presentation showcasing our project’s insights, progress and directions. The presentation explained our methodology, challenges, and solutions for combating counterfeit Bevacizumab. Our slides were well-received by peers and experts, which led to discussions and valuable feedback. We need to focus more on our affinity and sensitivity while ensuring a clear explanation to the judges of what aptamer is, even though our project was still at the early conception stage. We also participated in a poster showcase with other iGEMers, allowing us to communicate our projects to a broader audience visually.
                  </p>

                  <br />
                  <img src="https://static.igem.wiki/teams/5334/wiki-images/collaborations/collab-img1.webp">
                  </img>

                  <p>
                    A snapshot of the vibrant synthetic biology community at the 11th CCiC, teams around China come together to share new ideas, join in new projects, and spark new connections in the iGEM community. A spirit of curiosity and teamwork shines bright in this collective celebration of progress—passion for synthetic biology.
                  </p>

                  <br />
                  <br />
                  <img src="https://static.igem.wiki/teams/5334/wiki-images/collaborations/collab-img2.webp">
                  </img>

                  <p>
                    <strong>The BevaTech Team</strong> presented enthusiastically at the <strong>11th Conference of China iGEMer Community</strong>. By introducing our innovative project involving the detection of counterfeit Bevacizumab with the LFA technique, we interacted with the synthetic biology community, gained valuable feedback, and fostered discussions advancing our research
                  </p>


                  <br />
                  <br />
                  <img src="https://static.igem.wiki/teams/5334/wiki-images/collaborations/collab-img3.webp">
                  </img>

                  <p>
                    BevaTech team members proudly presented their project poster at the <strong>11th Conference of China iGEMer Community (CCiC)</strong>. This showcase provided a platform for us to visually communicate our research on counterfeit Bevacizumab detection using LFA technology, sparking engaging conversations with other teams and experts throughout the event.
                  </p>
                  <br />
                  <iframe title="CityU-HongKong: 11th Conference of China iGEMer Community (CCiC) Vlog (2024) [English]" width="100%" height="415" src="https://video.igem.org/videos/embed/19402349-5b62-4b00-ad40-6a4f094f723c" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>                </section>

                <section id="iGBA_2nd_Forum">
                  <br />
                  <br />
                  <h1>
                    2nd iGEM Greater Bay Area Forum
                  </h1>
                  <p>
                    The Greater Bay Area iGEM Forum is a regional event that fosters collaboration between iGEM teams and industry experts from the Guangdong-Hong Kong-Macao region. The forum focuses on bridging academia and industry to explore advancements in synthetic biology, serving as a hub for knowledge exchange and partnerships.
                  </p>
                  <p>
                    Though we did not deliver a formal presentation, we participated in the events specifically tailored as talks by start-up and group discussion. Attending talks by synthetic biology pioneers offered new insights into emerging trends and techniques. Networking sessions also provided opportunities for building connections with fellow iGEM teams, opening doors for potential collaborations, especially with startups and entrepreneurs.
                  </p>
                  <br />
                  <img src="https://static.igem.wiki/teams/5334/wiki-images/collaborations/collab-img4.webp">
                  </img>
                  <br />
                  <p>
                    <strong>The 2024 iGEM Greater Bay Area (iGBA) Forum</strong> was hosted at the prestigious Southern University of Science and Technology (SUSTech), bringing together iGEM teams across the Greater Bay Area to exchange ideas, collaborate, and showcase their innovative research in synthetic biology.
                  </p>

                  <br />
                  <br></br>
                  <img src="https://static.igem.wiki/teams/5334/wiki-images/collaborations/collab-img-5.webp">
                  </img>


                  <p>
                    A glimpse into one of the informative sessions at the 2024 iGBA Forum, hosted at SUSTech, attended by three of BevaTech's team members.
                  </p>

                  <iframe title="CityU-HongKong: 2nd iGEM Greater Bay Area Forum Vlog (2024) [English]" width="100%" height="415" src="https://video.igem.org/videos/embed/fb372877-0488-4174-ac72-bbe9b3f7d9f6" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>                </section>

                <section id="HK-Macau_Symposium">
                  <br />
                  <br />

                  <h1>
                    2024 HK-Macau iGEM Symposium
                  </h1>
                  <p>
                    The HK-Macau iGEM Symposium is an annual event for iGEM teams from Hong Kong and Macau, focusing on collaboration, research progress sharing, and learning from one another. The symposium features presentations, poster showcases, and talks by industry experts and educators, offering valuable opportunities for teams to refine their projects before the iGEM Grand Jamboree.                </p>
                  <p>
                    During the 2024 HK-Macau iGEM Symposium, our team was once again honoured and proud to present our project through presentation. This opportunity allowed us to delve deeper into our work and outreach efforts, receiving feedback from experts and educators in synthetic biology. We also have a poster showcase that complements our presentation by summarising key aspects of our research that initiate engaging conversation with teams and symposium attendees. The networking and opportunity provided at this event were invaluable for developing our project.                </p>

                  <br />
                  <img src="https://static.igem.wiki/teams/5334/wiki-images/collaborations/collab-img6.webp">
                  </img>
                  <br />

                  <p>
                    BevaTech team members delivered a comprehensive presentation on counterfeit medicines at the <strong>2024 HK-Macau iGEM Symposium</strong>. This engaging session detailed our innovative approach to tackling counterfeit Bevacizumab using LFA technology.
                  </p>

                  <br />
                  <img src="https://static.igem.wiki/teams/5334/wiki-images/collaborations/collab-img-7.jpg">
                  </img>
                  <br />

                  <p>
                    BevaTech members attended the 2024 Hong Kong-Macau iGEM Symposium, taking on the theme <strong>"Beyond the Bench: Bridging the Gap Between Research and Community."</strong> The symposium was mainly based on presentations by various teams. There were discussions with educators and industry experts, creating an inspiring atmosphere for all participants.
                  </p>

                  <iframe title="CityU-HongKong: 2024 HK-Macau iGEM Symposium (2024) [English]" width="100%" height="415" src="https://video.igem.org/videos/embed/2042a268-e003-482f-a6f1-3441bfbb5569" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>
                </section>


                <section id="APAC_Symposium">
                  <br />
                  <br />
                  <h1>
                    APAC Symposium: Mock Jamboree
                  </h1>
                  <p>
                    The <strong>APAC iGEM Jamboree</strong> is a regional event that brings together iGEM teams from across the Asia-Pacific to showcase their projects, share insights, and collaborate on addressing real-world challenges using synthetic biology. The event includes workshops, lectures, and presentations to enhance participants' understanding of synthetic biology applications and refine their project outcomes. Key features of this jamboree include a workshop on writing and structuring wikis, a session on applying synthetic biology to solve real-world problems, and a lecture by a Hong Kong Polytechnic University professor on using synthetic biology to create biofilms for water purification.
                  </p>
                  <p>
                    During the APAC Jamboree, BevaTech actively participated in various workshops and lectures, gaining valuable knowledge on better communicating our project through our wiki and how synthetic biology can be leveraged to address pressing global issues. On the second day, we delivered a presentation on our project focused on detecting counterfeit Bevacizumab using LFA technology. This presentation allowed us to receive constructive feedback from the regional iGEM community, further refining our approach as we move forward in the competition.
                  </p>
                </section>




                <br />
                <br />
                <br />
                <br />



              </>
            </div>
          } />
        </div>

      </section>
    </div>
  );
}

export default Collaborations;
